import { render, staticRenderFns } from "./KundeBoardMessageIcon.vue?vue&type=template&id=4e4f85b6&scoped=true&"
import script from "./KundeBoardMessageIcon.vue?vue&type=script&lang=js&"
export * from "./KundeBoardMessageIcon.vue?vue&type=script&lang=js&"
import style0 from "./KundeBoardMessageIcon.vue?vue&type=style&index=0&id=4e4f85b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e4f85b6",
  null
  
)

export default component.exports